module.exports = __webpack_public_path__ + "img/idealwero.5f45c33c.svg";